import { Result as AntdResult } from "antd";

import type { ResultProps } from "./types";

/**
 * Used to feedback the results of a series of operational tasks.
 */
const Result = (props: ResultProps) => <AntdResult {...props} />;

export { Result };
